import { render, staticRenderFns } from "./CustomerAndAddresses.vue?vue&type=template&id=629c86cb&scoped=true&"
import script from "./CustomerAndAddresses.vue?vue&type=script&lang=js&"
export * from "./CustomerAndAddresses.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAndAddresses.vue?vue&type=style&index=0&id=629c86cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629c86cb",
  null
  
)

/* custom blocks */
import block0 from "./CustomerAndAddresses.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports